import {setAccessibility, setPage, setShowSidebar} from "../../store/general/generalSlice";
import {store} from "../../store/store";
import closeIcon from "../../assets/icon-close-black.svg";
import useStyles from "./sidebar.css";
import {useDispatch, useSelector} from "react-redux";
import {getShowSidebar, isAccessibilityActive} from "../../store/general/general.selector";
import SidebarButton from "./sidebarButton/sidebarButton";
const logo = "/icons/logo.svg"

const Sidebar = () => {
    const classes = useStyles();
    const showSidebar = useSelector(getShowSidebar)
    const accessibility = useSelector(isAccessibilityActive);
    const dispatch = useDispatch();
    const toggleAccessibility = () => {
        dispatch(setAccessibility(!accessibility));
    }
    const {names} = window.strings.staticModals
    const onClose = () => store.dispatch(setShowSidebar(false));
    const accessibilityText = accessibility ? window.strings.accessibility.toggleOff : window.strings.accessibility.toggleOn;
    if (!showSidebar) return <></>
    return <div className={classes.modalBackground} onClick={onClose}>
        <div className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={classes.closeIcon} onClick={onClose}><img src={closeIcon} alt={"close icon"}/></button>
            <div className={classes.logoAndAccessDiv}>
                <img className={classes.logo} src={logo} alt={"kolsherut logo"} onClick={() => {
                    store.dispatch(setPage('home'));
                    onClose();
                }}/>
            </div>
            <SidebarButton text={names.about} page={"about"}/>
            <SidebarButton text={names.addService} page={"missing"}/>
            <SidebarButton text={names.partners} page={"partners"}/>
            <SidebarButton text={names.contact} page={"contact"}/>
            <SidebarButton text={accessibilityText} onClick={toggleAccessibility}/>
        </div>
    </div>
};
export default Sidebar;
